import React, { Fragment } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import Occup_sel from "./occupancy_selector";

class Grid_preview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      components: {
        //selectcellEditor:getnumber(value),
        //selectcellEditor_child:getnumber2(value),
      },
      frameworkComponents: {
        selectcellEditor: Occup_sel,

        //selectcellEditor_child:Occup_sel
      },
    };
  }

  render() {
    // console.log("data", this.props.Rows);
    return (
      <Fragment>
        <div
          className="ag-theme-balham"
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          <AgGridReact
            columnDefs={this.props.Columns}
            rowData={this.props.Rows}
            rowClassRules={this.props.rowClassRules}
            frameworkComponents={this.state.frameworkComponents}
            onCellValueChanged={(e) => this.props.onCellValueChanged(e)}
            onGridReady={this.props.onGridReady}
          ></AgGridReact>
        </div>
      </Fragment>
    );
  }
}

export default Grid_preview;
